import { View, Text, StyleSheet } from "react-native";

import { colors, fonts, spacing } from "@/lib/theme";

interface VisitHeaderProps {
    patientFirstName: string;
    patientLastName: string;
    age: number | null;
    gender: string | null;
    language: string | null;
}

export function VisitHeader({
    patientFirstName,
    patientLastName,
    age,
    gender,
    language
}: VisitHeaderProps) {
    return (
        <View style={styles.container}>
            <Text style={styles.patientName}>
                {patientFirstName} {patientLastName}
            </Text>
            <Text style={styles.demographics}>
                {age != null ? `${age} Yo` : "Age unknown"}, {gender ?? "Unknown"}
            </Text>
            {language ? <Text style={styles.language}>{language}</Text> : null}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: spacing.base,
        paddingTop: spacing.lg,
        paddingBottom: spacing.md
    },
    patientName: {
        fontFamily: fonts.bold,
        fontSize: 24,
        color: colors.textPrimary,
        lineHeight: 30
    },
    demographics: {
        fontFamily: fonts.medium,
        fontSize: 14,
        color: colors.textSecondary,
        marginTop: 2
    },
    language: {
        fontFamily: fonts.medium,
        fontSize: 14,
        color: colors.textSecondary,
        marginTop: 2
    }
});
